/**
 * Gates the dashboard behind a /api/me check. While the check is in flight
 * we render nothing (a spinner here would just flash). On 401 the api()
 * helper already redirects to /auth/login, so we don't need to handle that
 * case explicitly.
 */

import { useQuery } from '@tanstack/react-query';
import { Outlet } from 'react-router';
import { api } from '@/lib/api';
import type { MeResponse } from '@oakallow/shared';

export default function RequireAuth() {
  const { isPending, isError } = useQuery({
    queryKey: ['me'],
    queryFn: () => api<MeResponse>('/api/me'),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  if (isPending) return null;
  if (isError) return null; // api() will have redirected already

  return <Outlet />;
}
